import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation clearNpoReportAnswerValidation(
    $reportId: Int,
    $investmentId: Int,
  ) {
    clearNpoReportAnswerValidation(
      reportId: $reportId,
      investmentId: $investmentId,
    ) {
      success
    }
  }
`;

export function useClearNpoReportAnswerValidations() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    try {
      mutate(query, variables, (response) => {
        if (typeof onFinish === 'function') {
          onFinish(response.newNpoReportAnswerValidation.id);
        }
      });
    } catch (err) {
      console.warn(err);
    }
  };
  return { data, isLoading, run };
}
